import { SxProps, Theme } from '@mui/material';

export const gridFatherSX: SxProps<Theme> = {
	backgroundColor: '#FBFBFC',
	columnGap: '14px',
	marginBottom: {
		/* xs: '0px',  sm: '34px' */
	},
};
